import { render, staticRenderFns } from "./PropertiesForSale.vue?vue&type=template&id=31d0788a&"
import script from "./PropertiesForSale.vue?vue&type=script&lang=ts&"
export * from "./PropertiesForSale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports